import dotPropImmutable from 'dot-prop-immutable';
// DEAD CODE - Todo @Muskaan- remove this
export const revenueRecognitionSlice = {
    updateRecognitionConfigAction: (state, { payload: { milestoneRevenueRecognitionConfigs } })=>{
        const path = `data.${state.activeId}.milestoneRevenueRecognitionConfigs`;
        const recognitionConfig = milestoneRevenueRecognitionConfigs.filter((item)=>item.recognisedPercentage);
        return dotPropImmutable.set(state, path, recognitionConfig);
    }
};
